import { useMemo, type ComponentProps, type ReactNode } from 'react'
import SolidCheckCircleIcon from 'LuxKit/Icons/solid/SolidCheckCircleIcon'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import type { PackageInclusionCategory } from './packageInclusions'

interface Props {
  inclusion: App.OfferInclusion
  category?: PackageInclusionCategory
  endIcon?: ReactNode
}

const categoryColours = {
  'lux-plus': 'lux-plus',
  exclusive: 'highlight-primary-dark',
  'night-extra': 'success-dark',
  standard: 'light-foreground-alt',
} as const

function AccommodationPackageInclusionItem({ inclusion, category = 'standard', endIcon }: Props) {
  const displayedInclusion = useMemo<ComponentProps<typeof OfferInclusionItem>['inclusion']>(() => ({
    ...inclusion,
    isHighlighted: category === 'exclusive' || inclusion.isHighlighted,
    Icon: SolidCheckCircleIcon,
    colour: categoryColours[category],
  }), [category, inclusion])
  return <OfferInclusionItem inclusion={displayedInclusion} size="small" iconSize={16} iconColour={category === 'standard' ? 'success-dark' : categoryColours[category]} endIcon={endIcon} />
}

export default AccommodationPackageInclusionItem
